var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppStoreLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1122_16765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4965 11.6776C14.5071 10.8599 14.7243 10.0581 15.1279 9.34693C15.5316 8.63573 16.1086 8.03819 16.8052 7.60991C16.3626 6.97786 15.7788 6.45771 15.1001 6.09077C14.4213 5.72383 13.6664 5.52021 12.8952 5.49608C11.2501 5.32341 9.65519 6.48049 8.81688 6.48049C7.96234 6.48049 6.67162 5.51323 5.28172 5.54183C4.3827 5.57087 3.50654 5.8323 2.73859 6.30064C1.97065 6.76898 1.33712 7.42826 0.899725 8.21425C-0.994963 11.4946 0.418303 16.3156 2.23326 18.9672C3.14131 20.2656 4.20258 21.716 5.59121 21.6646C6.95008 21.6082 7.45759 20.7981 9.09786 20.7981C10.7229 20.7981 11.199 21.6646 12.6159 21.6319C14.074 21.6082 14.9927 20.3277 15.8689 19.017C16.5213 18.0918 17.0234 17.0693 17.3564 15.9873C16.5093 15.629 15.7864 15.0293 15.2778 14.2629C14.7692 13.4965 14.4975 12.5974 14.4965 11.6776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8202 3.75267C12.6152 2.79827 13.0069 1.57154 12.9121 0.333008C11.6974 0.460581 10.5755 1.0411 9.7697 1.95888C9.37573 2.40725 9.07399 2.92886 8.88174 3.49391C8.68948 4.05895 8.61048 4.65635 8.64924 5.25195C9.25677 5.2582 9.8578 5.12652 10.4071 4.86682C10.9563 4.60712 11.4395 4.22618 11.8202 3.75267Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1122_16765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.3564,
    height: 21.3333,
    fill: "white",
    transform: "translate(0 0.333008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreLogo);
export default __webpack_public_path__ + "static/media/app-store-logo.80ddcae38d70a0bf5bc53e8e02be4409.svg";
export { ForwardRef as ReactComponent };